export default function () {
    var pointsJson = window.PointsJson;

    if (pointsJson) {
        var pointsArray = pointsJson.Points;
        var showcaseContainer = $('.showcase-container').parent();

        if (pointsJson.length === 0) return;

        showcaseContainer.addClass('has-points');

        var pointsCanvas = $('<div class="showcase-points-canvas"></div>');

        pointsArray.forEach((point, index) => {
            var pointDot = $(`<span style="top: ${point.Top}%; left: ${point.Left}%;" class="showcase-point" data-showcase-pointid="${index}">${index + 1}</span>`);

            pointsCanvas.append(pointDot);

            pointDot.on('mousedown', function (e) {
                var dr = $(this).addClass("drag").css("cursor", "move");
                var height = dr.outerHeight();
                var width = dr.outerWidth();
                var max_left = dr.parent().offset().left + dr.parent().width() - dr.width();
                var max_top = dr.parent().offset().top + dr.parent().height() - dr.height();
                var min_left = dr.parent().offset().left;
                var min_top = dr.parent().offset().top;

                var ypos = dr.offset().top + height - e.pageY,
                    xpos = dr.offset().left + width - e.pageX;
                $(document.body).on('mousemove', function (e) {
                    var itop = e.pageY + ypos - height;
                    var ileft = e.pageX + xpos - width;

                    if (dr.hasClass("drag")) {
                        if (itop <= min_top) { itop = min_top; }
                        if (ileft <= min_left) { ileft = min_left; }
                        if (itop >= max_top) { itop = max_top; }
                        if (ileft >= max_left) { ileft = max_left; }
                        dr.offset({ top: itop, left: ileft });
                    }
                }).on('mouseup', function (e) {
                    dr.removeClass("drag");

                    var dragContainer = {
                        width: dr[0].parentElement.scrollWidth,
                        height: dr[0].parentElement.scrollHeight
                    };

                    var dragPos = {
                        left: dr[0].offsetLeft + 14,
                        top: dr[0].offsetTop + 14
                    };

                    $('.showcases-points-table .grid-row')[index].querySelector('.showcase-left-input').value = (dragPos.left / dragContainer.width * 100).toFixed(2).replace('.', ',');
                    $('.showcases-points-table .grid-row')[index].querySelector('.showcase-top-input').value = (dragPos.top / dragContainer.height * 100).toFixed(2).replace('.', ',');
                });
            });
        });

        showcaseContainer.append(pointsCanvas);

        var currentHoveredPoint = null;

        $('.showcase-point').mouseenter(function (e) {
            currentHoveredPoint = $(this);

            $('.showcases-points-table .grid-row')[+currentHoveredPoint.data('showcase-pointid')].classList.add('over-point-hover');
        });

        $('.showcase-point').mouseleave(function (e) {
            $('.showcases-points-table .grid-row')[+currentHoveredPoint.data('showcase-pointid')].classList.remove('over-point-hover');

            currentHoveredPoint = null;
        });

        $('.showcases-points-table .grid-row').mouseenter(function () {
            var index = $(this).index() - 1;

            $(`[data-showcase-pointid=${index}]`).addClass('row-hover');
        }).mouseleave(function () {
            var index = $(this).index() - 1;

            $(`[data-showcase-pointid=${index}]`).removeClass('row-hover');
        });
    }
}